
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    PRACTICEDRILL_ACTION,
    ALL_PRACTICEDRILL,
    ADD_PRACTICEDRILL,
    FETCH_PRACTICEDRILL,
    EDIT_PRACTICEDRILL,
    DELETE_PRACTICEDRILL
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Practice Drill Actions
 */


    export const allPracticeDrill = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: PRACTICEDRILL_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getpractdrllst', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_PRACTICEDRILL, payload: alldata });
            });
        }        
    
    }

    export const addPracticeDrill = (data) =>{
    
        var payload={
            "shot":data.target.drillshot.value,
            "type":data.target.drilltype.value,
            "drill":data.target.desc.value
        }
        return (dispatch) => { 
            dispatch({ type:PRACTICEDRILL_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addpractdrllst', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allPracticeDrill()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_PRACTICEDRILL});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchPracticeDrill = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:PRACTICEDRILL_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchpractdrill', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PRACTICEDRILL, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editPracticeDrill = (data, id) =>{
    
        var payload={
            "id":id,
            "shot":data.target.drillshot.value,
            "type":data.target.drilltype.value,
            "drill":data.target.desc.value
        }
        return (dispatch) => { 
            dispatch({ type:PRACTICEDRILL_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editpractdrllst', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allPracticeDrill()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_PRACTICEDRILL});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deletePracticeDrill = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:PRACTICEDRILL_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletepractdrllst', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allPracticeDrill()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_PRACTICEDRILL});                    
                }
                
                
            });
        
        }
    }


   

